export default {
    "driverStatusDelete_title": "Eliminar Estados de Conductor",
    "driverStatusDelete_deleteWarning": "¿Está seguro de que desea eliminar los siguientes estados de conductor? Esta acción no se puede deshacer",
    "driverStatusDelete_success": "Exito",
    "driverStatusDelete_successMessage": "Estados de conductor eliminados exitosamente",
}